<template>
<div>
   <div class="row justify-content-center align-items-center">
        <div class="col-md-12 col-lg-6 residentportal-default__column d-flex align-items-center justify-content-center">
            <div class="residentportal-default-left">
                <h2 class="residentportal-default-left__title">{{LandingPageContent.login_heading}} </h2>
                <div v-html="LandingPageContent.login_content"></div>
                <button type="submit" class="btn btn-tru-green residentportal-default-left__btn" :style="'background-color:' + MainUISettings.main_site_button_color" @click="mainSiteLink()">{{ TEXTS.render(`LOGIN_MAIN_SITE_LINK`, null, null, {skipCasing : true}) }}</button>
            </div>
            <div class="residentportal-default-left__bg centered-bg-image" v-bind:style="'background: url('+ pubPath + MainUISettings.landing_page_image +'); box-shadow: rgba(0, 45, 81, 0.5) 0px 0px 0px 2000px inset'" ></div>
        </div>
        <div class="col-md-12 col-lg-6 residentportal-default__column d-flex align-items-center justify-content-center" id="main-content">
            <ResetPasswordForm />
        </div>
    </div>
</div>
</template>

<script>
import Texts from '../../../../common/utils/Texts'
import ResetPasswordForm from './ResetPasswordForm';

    export default {
        data() {
            return {
                pubPath: process.env.MIX_APP_URL
            }
        },
        components: {
            ResetPasswordForm
        },
        methods: {
            mainSiteLink: function(){
                window.open(this.$store.getters.GET_LANDING_PAGE_CONTENT.registration_button_link);
            }
        },
        computed: {
            TEXTS: () => Texts,
            MainUISettings() {
                return this.$store.getters['GET_MAIN_UI']; 
            },
            LandingPageContent() {
                return this.$store.getters['GET_LANDING_PAGE_CONTENT']; 
            }
        },
        mounted() {
            this.$store.dispatch('landingPageContent');
        }
    }
</script>
